<script>
import { ElementMixin } from "vue-slicksort";
import Loader from "./Loader";
import weatherIcon from "../weatherIcon";

export default {
  name: "LocationCard",
  mixins: [ElementMixin],
  components: {
    loader: Loader,
  },
  props: {
    loc: Object,
    index: Number
  },
  mounted() {
    this.$store.dispatch('refreshLocation', this.index);
  },
  computed: {
    icon() {
      return weatherIcon(this.loc.weather.current.weather[0].id);
    },
  },
};
</script>
<template>
  <div class="location-card" @contextmenu.prevent>
    <template v-if="loc.loaded">
      <div class="loc">
        <div class="city">{{ loc.text }},</div>
        <div class="country">{{ loc.context.map((c) => c.text).join(", ") }}</div>
      </div>
      <div class="preview">
        <div class="temp">
          <span class="value">{{ loc.weather.current.temp.toFixed(0) }}</span>
          <span class="unit">°C</span>
        </div>
        <img :src="icon" alt="icon" class="icon" />
      </div>
    </template>
    <div v-else class="center">
      <loader />
    </div>
  </div>
</template>
<style lang="scss">
.location-card {
  user-select: none;
  height: 84px;
  border-radius: 10px;
  background-color: var(--card-color);
  box-shadow: var(--light-shadow);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px;
  padding: 10px 20px;

  .loc {
    position: relative;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    margin-right: 10px;
    flex-grow: 1;

    .city {
      font-size: 24px;
      color: var(--text-color);
      line-height: 110%;
    }

    .country {
      font-size: 14px;
      color: var(--light-color);
    }
  }

  .preview {
    display: flex;
    align-items: flex-end;

    .temp {
      display: flex;
      align-items: flex-start;

      .value {
        font-weight: bold;
        font-size: 40px;
        color: var(--text-color);
        line-height: 100%;
      }

      .unit {
        font-size: 18px;
        color: var(--light-color);
        line-height: 120%;
      }
    }

    .icon {
      height: 48px;
      width: 48px;
      object-fit: contain;
      object-position: center;
      margin-left: 10px;
    }
  }

  &.sort {
    box-shadow: var(--dark-shadow);
  }
}
</style>